import apiClient from "../api/apiClient";
import { Notify } from "../../helpers/notification";

const PARKING_LOADING = () => ({ type: "PARKING_LOADING" });
const PARKING_COMPLETE = () => ({ type: "PARKING_COMPLETE" });

export const GetVehicles = () => (dispatch) =>
  apiClient
    .get("/parking")
    .then((r) => {
      dispatch({ type: "SET_VEHICLES", payload: r.data.data || [] });
    })
    .catch(() => {});

export const GetSpots = () => (dispatch) =>
  apiClient
    .get("/parking/spots")
    .then((r) => {
      dispatch({ type: "SET_PARKING_SPOTS", payload: r.data.data || [] });
    })
    .catch(() => {});

export const AddParking = (payload, cb) => (dispatch) => {
  dispatch(PARKING_LOADING());
  apiClient
    .post("/parking", payload)
    .then(() => {
      dispatch(GetVehicles());
      dispatch(GetSpots());
      dispatch(PARKING_COMPLETE());
      cb && cb();
      Notify("success", "Vehicle added");
    })
    .catch((err) => {
      dispatch(PARKING_COMPLETE());
      const msg =
        err?.response?.data?.error || "Could not add vehicle";
      Notify("danger", typeof msg === "string" ? msg : "Could not add vehicle");
    });
};

export const EditParking = (zzID, payload, cb) => (dispatch) => {
  dispatch(PARKING_LOADING());
  apiClient
    .patch(`/parking/${zzID}`, payload)
    .then(() => {
      dispatch(GetVehicles());
      dispatch(GetSpots());
      dispatch(PARKING_COMPLETE());
      cb && cb();
      Notify("success", "Vehicle updated");
    })
    .catch((err) => {
      dispatch(PARKING_COMPLETE());
      const msg =
        err?.response?.data?.error || "Could not update vehicle";
      Notify("danger", typeof msg === "string" ? msg : "Could not update vehicle");
    });
};

export const ToggleArchiveParking = (zzID, payload, cb) => (dispatch) => {
  dispatch(PARKING_LOADING());
  apiClient
    .post(`/parking/${zzID}/archive`, payload)
    .then(() => {
      dispatch(GetVehicles());
      dispatch(GetSpots());
      dispatch(PARKING_COMPLETE());
      cb && cb();
    })
    .catch(() => {
      dispatch(PARKING_COMPLETE());
      Notify("danger", "Could not archive vehicle");
    });
};

export const GetCarInfoAction = (cb) => (dispatch) => {
  apiClient
    .get("/parking/car-info")
    .then((r) => {
      dispatch({ type: "SET_CAR_INFO", payload: r.data.data || [] });
      cb && cb();
    })
    .catch(() => {});
};
